import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCarAlt, FaTruck, FaBoxes, FaExchangeAlt, FaQuestionCircle, FaStackExchange, FaGlobeAfrica, FaCreditCard, FaTimes } from 'react-icons/fa';
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from '../../composant_reutilisable/navbar';
import useAuth from '../../composant_reutilisable/useAuth';
import { useNavigate } from 'react-router-dom';
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Pas_acces from '../../composant_reutilisable/pas_acces';
import axios from 'axios';
import Footer from '../../composant_reutilisable/footer';
import { Modal } from 'react-bootstrap';

const Gestion_des_tours_parc = () => {
    useAuth();
    const user_id = localStorage.getItem('userId');
    const navigate = useNavigate();
    const accesGroupe = JSON.parse(localStorage.getItem('accesGroupe')) || [];

    const [userData, setUserData] = useState({});
    const [parcs, setParcs] = useState([]);
    const [showGlossary, setShowGlossary] = useState(false);
    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);

    // États pour le modal
    const [showModal, setShowModal] = useState(false);
    const [selectedParc, setSelectedParc] = useState(null);

    // État pour les parcs affectés à l'utilisateur
    const [parcsAffectes, setParcsAffectes] = useState([]);

    useEffect(() => {
        const fetchUserData = async () => {
            const token = localStorage.getItem('access_token');
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setUserData(data);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération du profil:", error);
            }
        };

        fetchUserData();
    }, [user_id]);

    const fetchParcs = async () => {
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/",
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (response.ok) {
                const data = await response.json();
                // console.log(data);
                setParcs(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des parcs:", error);
        }
    };

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Parcs";
        }
        fetchParcs();
    }, [user_id]);

    // Extraire les parcs affectés à l'utilisateur
    useEffect(() => {
        if (userData?.parc && parcs.length > 0) {
            const parcValue = userData.parc;
            
            // Si l'utilisateur n'est affecté à aucun parc
            if (parcValue === "Non affecté" || !parcValue) {
                setParcsAffectes([]);
                return;
            }

            let refsParcs = [];
            if (parcValue.includes(',')) {
                refsParcs = parcValue.split(',').map(p => p.trim()).filter(p => p);
            } else {
                refsParcs = [parcValue.trim()];
            }

            // Filtrer les parcs correspondant aux références
            const parcsTrouves = parcs.filter(parc => refsParcs.includes(parc.ref_parc));
            setParcsAffectes(parcsTrouves);
            
            // console.log("🔍 Parcs affectés à l'utilisateur:", parcsTrouves);
        }
    }, [userData, parcs]);


    const handleParcClick = (parc) => {
        setSelectedParc(parc);
        setShowModal(true);
    };

    const handleOptionClick = (optionType) => {
        if (!selectedParc) return;

        if (optionType === 'camion') {
            // Rediriger vers la page appropriée selon le type de parc
            if (selectedParc.type_parc === "national") {
                navigate('/Gestion-des-tours-national', {
                    state: { parcRef: selectedParc.ref_parc }
                });
            } else if (selectedParc.type_parc === "international") {
                navigate('/Gestion-des-tours-international', {
                    state: { parcRef: selectedParc.ref_parc }
                });
            }
        } else if (optionType === 'fret') {
            // Rediriger vers la liste des déclarations de fret
            navigate('/Liste-declaration-fret', {
                state: { parcRef: selectedParc.ref_parc }
            });
        }

        setShowModal(false);
    };

    const userHasAccess = (accessKey) => {
        return accesGroupe.includes(accessKey);
    };

    // const isAdminUser = () => {
    //     return accesGroupes.includes("Administration");
    // };

    const isAdminUser = () => ["Administration", "Supervision"].some(role => accesGroupes.includes(role));


    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            const token = localStorage.getItem('access_token');
            try {
                const groupe = localStorage.getItem('groupe_id');
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`,
                    {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    // useEffect(() => {
    //     if (accesGroupes.length > 0 && userData?.parc && parcs.length > 0) {
    //         if (!accesGroupes.includes("Fret")) {
    //             if (accesGroupes.includes("Gestion_tours_national") && hasNationalAccess()) {
    //                 navigate("/Gestion-des-tours-national");
    //             } else if (accesGroupes.includes("Gestion_tours_international") && hasInterNationalAccess()) {
    //                 navigate("/Gestion-des-tours-international");
    //             }
    //         }
    //     }
    // }, [accesGroupes, userData, parcs, navigate]);

    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        if (accesGroupes.length > 0 && userData?.parc && parcs.length > 0) {
            const parcsUtilisateur = parcs.filter(p => {
                if (userData.parc === "Non affecté" || !userData.parc) return false;
                const refs = userData.parc.includes(',') 
                    ? userData.parc.split(',').map(r => r.trim())
                    : [userData.parc.trim()];
                return refs.includes(p.ref_parc);
            });

            // Si l'utilisateur a plusieurs parcs, on les affiche tous
            if (parcsUtilisateur.length > 0) {
                setParcsAffectes(parcsUtilisateur);
            }

            // 🔴 Cas : Mise_en_file sans Fret et un seul parc -> redirection automatique
            if (accesGroupes.includes("Mise_en_file") && !accesGroupes.includes("Fret") && parcsUtilisateur.length === 1) {
                const userParc = parcsUtilisateur[0];
                if (userParc.type_parc === "national") {
                    navigate("/Gestion-des-tours-national", { state: { parcRef: userParc.ref_parc } });
                } else if (userParc.type_parc === "international") {
                    navigate("/Gestion-des-tours-international", { state: { parcRef: userParc.ref_parc } });
                }
                return;
            }

            // 🔵 Cas : Fret sans Mise_en_file -> redirection vers la liste de fret
            if (accesGroupes.includes("Fret") && !accesGroupes.includes("Mise_en_file") && parcsUtilisateur.length === 1) {
                const userParc = parcsUtilisateur[0];
                navigate("/Liste-declaration-fret", { state: { parcRef: userParc.ref_parc } });
                return;
            }

            setIsReady(true);
        }
    }, [accesGroupes, userData, parcs, navigate]);

    if (
        !accesGroupes.includes("Fret") &&
        !accesGroupes.includes("Mise_en_file")
    ) {
        return <Pas_acces />;
    }

    // Fonction pour obtenir l'icône en fonction du type de parc
    const getParcIcon = (typeParc) => {
        switch (typeParc) {
            case 'national':
                return <FaTruck className="text-primary" />;
            case 'international':
                return <FaGlobeAfrica className="text-success" />;
            default:
                return <FaCarAlt className="text-secondary" />;
        }
    };

    // Fonction pour obtenir la classe CSS en fonction du type de parc
    const getParcCardClass = (typeParc) => {
        switch (typeParc) {
            case 'national':
                return 'border-primary';
            case 'international':
                return 'border-success';
            default:
                return 'border-secondary';
        }
    };

    // Déterminer la liste des parcs à afficher
    const parcsAAfficher = isAdminUser() 
        ? parcs  // Les admins voient tous les parcs
        : parcsAffectes.length > 0 
            ? parcsAffectes  // Les utilisateurs voient leurs parcs affectés
            : [];

    // Vérifier si l'utilisateur a au moins un parc affecté
    const aUnParcAffecte = parcsAffectes.length > 0;

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaExchangeAlt size={25} className='mr-2' /> Mise en file
                                </div>
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Mise en file</li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight p-5">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5>Sélection du parc</h5>
                            {!isAdminUser() && parcsAffectes.length > 0 && (
                                <span className="badge badge-primary">
                                    {parcsAffectes.length} parc(s) affecté(s)
                                </span>
                            )}
                        </div>
                        {!isReady ? (
                            // 🔄 Loader uniquement dans la zone des parcs
                            <div className="col-12 text-center mt-5">
                                <div className="spinner-border text-primary" />
                                <p className="mt-3">Chargement des parcs...</p>
                            </div>
                        ) : (!aUnParcAffecte && !isAdminUser()) ? (
                            // 🚫 Cas 1 : utilisateur sans parc et non admin
                            <div className="alert alert-warning mx-auto" style={{ maxWidth: "600px" }}>
                                <h4 className="text-danger">Aucun parc assigné</h4>
                                <p>
                                    Vous n’avez pas encore été affecté à un parc.<br />
                                    Veuillez contacter un administrateur pour obtenir une affectation.
                                </p>
                                <button
                                    className="btn btn-primary mt-3"
                                    onClick={() => navigate("/Menu")}
                                >
                                    Retour à l’accueil
                                </button>
                            </div>
                        ) : (
                            // ✅ Cas 2 : utilisateur admin ou affecté à un parc
                            <div className="row mx-auto justify-content-center">
                                {parcsAAfficher.map((parc) => (
                                    <div key={parc.id} className="col-md-3 col-sm-6 mb-4">
                                        <div
                                            className={`card rounded shadow-sm h-100 d-flex flex-column justify-content-center align-items-center ${getParcCardClass(parc.type_parc)}`}
                                            onClick={() => handleParcClick(parc)}
                                            style={{
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s',
                                                border: '2px solid'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                        >
                                            <div className="card-body text-center">
                                                <div className="mb-3 icon-large">
                                                    {getParcIcon(parc.type_parc)}
                                                </div>
                                                <h5 className="card-title">{parc.nom_parc}</h5>
                                                <p className="card-text mb-1">
                                                    <small className="text-muted">
                                                        Email : <strong>{parc.email_parc}</strong>
                                                    </small>
                                                </p>

                                                <p className="card-text mb-1">
                                                    <small className="text-muted">
                                                        Contact : <strong>{parc.tel_parc}</strong>
                                                    </small>
                                                </p>

                                                {parc.ref_parc && (
                                                    <p className="card-text">
                                                        <small className="text-muted">
                                                            Référence : {parc.ref_parc}
                                                        </small>
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}


                        {parcs.length === 0 && (
                            <div className="text-center mt-5">
                                <div className="spinner-border text-primary" role="status">
                                </div>
                                <p className="mt-3">Chargement des parcs...</p>
                            </div>
                        )}
                    </div>

                    {/* Modal de sélection d'option */}
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                        <Modal.Header>
                            <Modal.Title>
                                Options pour {selectedParc?.nom_parc}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center">
                            <p className="mb-4">Sélectionnez une option pour ce parc :</p>

                            <div className="row">
                                {/* Option Camion */}
                                <div className="col-md-6 mb-3">
                                    <div
                                        className="card h-100"
                                        onClick={() => handleOptionClick('camion')}
                                        style={{
                                            cursor: 'pointer',
                                            transition: 'transform 0.2s',
                                            border: '2px solid #007bff'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        <div className="card-body text-center">
                                            <FaTruck size={30} className="text-primary mb-3" />
                                            <h6>Camion</h6>
                                            <small className="text-muted">
                                                Gestion des tours de {selectedParc?.type_parc === 'national' ? 'fret domestique' : 'fret en transit'}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                {/* Option Fret */}
                                <div className="col-md-6 mb-3">
                                    <div
                                        className="card h-100"
                                        onClick={() => handleOptionClick('fret')}
                                        style={{
                                            cursor: 'pointer',
                                            transition: 'transform 0.2s',
                                            border: '2px solid #28a745'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        <div className="card-body text-center">
                                            <FaBoxes size={30} className="text-success mb-3" />
                                            <h6>Fret</h6>
                                            <small className="text-muted">
                                                Liste des déclarations de fret
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setShowModal(false)}
                            >
                                <FaTimes className="mr-2" />
                                Fermer
                            </button>
                        </Modal.Footer>
                    </Modal>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default Gestion_des_tours_parc;